<template>
  <div id="team">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all" v-if="$route.meta.keepAliveSub">
      <div class="con_box2">
        <div class="team_bbox" v-html="showIntroduction()"></div>
        <div class="team_mbox">
          <router-link :to="{ name: 'team_type', params:{ teamtypeid:1} }">{{showPage.menTeam}}</router-link>
        </div>
        <div class="team_mbox2">
          <router-link :to="{ name: 'team_type', params:{ teamtypeid:0} }">{{showPage.womenTeam}}</router-link>
        </div>
        <div class="fix"></div>
      </div>
    </div>
    <router-view :teams="teams"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'team',
  data() {
    return {
      teams: [],
      teamInfo: {},
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initTeams();
      this.initTeamInfo();
    },
    initTeams() {
      this.getTeamsData();
    },
    initTeamInfo() {
      this.getTeamInfo();
    },
    
    getTeamsData() {
      axios.get(API.team)
        .then(response => {
          this.teams = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getTeamInfo() {
      axios.get(API.setting + '?id=1')
        .then(response => {
          this.teamInfo = response.data;
          this.handleReceivedTeamInfo();
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    handleReceivedTeamInfo() {
      this.teamInfo.teamIntroductionCh = (this.teamInfo.teamIntroductionCh);
      this.teamInfo.teamIntroductionEn = (this.teamInfo.teamIntroductionEn);
    },
    

    showIntroduction() {
      let introduction = {CH: this.teamInfo.teamIntroductionCh, 
                          EN: this.teamInfo.teamIntroductionEn};
      return introduction[sessionStorage.locale];
    }
  },
}

</script>
<style lang="scss">
#team {
  a {
    color: #11574F;
  }
}

</style>



// WEBPACK FOOTER //
// Team.vue?0c87c43f